import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './country-selector.component.scss';
import * as $ from 'jquery';
var CountrySelector = /** @class */ (function (_super) {
    tslib_1.__extends(CountrySelector, _super);
    function CountrySelector(element) {
        return _super.call(this, element) || this;
    }
    CountrySelector.prototype.init = function () {
        var _this = this;
        this.countries = [];
        $('.country-selector__section-country').each(function (index, el) {
            _this.countries.push({
                country: $(el).data('country'),
                section: $(el).data('section'),
                element: $(el)
            });
        });
    };
    CountrySelector.prototype.bindEvents = function () {
        var _this = this;
        $('.country-selector__close').click(function () {
            $('.country-selector__modal').addClass('country-selector__modal--disappear');
            setTimeout(function () {
                $('.country-selector__modal')
                    .removeClass('country-selector__modal--reveal')
                    .removeClass('country-selector__modal--disappear');
            }, 400);
        });
        $('.country-selector__search-input').keyup(function () {
            var searchParam = $('.country-selector__search-input').val().toLowerCase();
            if (searchParam.length > 0) {
                $('.country-selector__section').hide();
                $('.country-selector__section-country').hide();
                _this.countries.filter(function (item, index) {
                    return item.country.toLowerCase().indexOf(searchParam) > -1;
                }).forEach(function (country) {
                    country.element.show();
                    $(".country-selector__section[data-section='" + country.section + "']").show();
                });
            }
            else {
                _this.countries.forEach(function (country) {
                    country.element.show();
                    $(".country-selector__section").show();
                });
            }
        });
    };
    return CountrySelector;
}(Base));
export { CountrySelector };



//////////////////
// WEBPACK FOOTER
// ./components/country-selector/country-selector.component.ts
// module id = 237
// module chunks = 0